import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from "react";
import { CardFieldRenderer } from "./CardFieldRenderer";
export function DynamicCard({ card, onSubmit, onSkip }) {
    const [values, setValues] = useState({});
    const [submitting, setSubmitting] = useState(false);
    const [done, setDone] = useState(false);
    const handleChange = (key, value) => {
        setValues((prev) => ({ ...prev, [key]: value }));
    };
    const [error, setError] = useState(null);
    const handleSubmit = async () => {
        setSubmitting(true);
        setError(null);
        try {
            await onSubmit(card.card_id, card.card_type, values);
            setDone(true);
        }
        catch (err) {
            setError(err instanceof Error ? err.message : String(err));
        }
        finally {
            setSubmitting(false);
        }
    };
    if (done) {
        return (_jsx("div", { className: "mt-3 rounded-xl border border-emerald-800 bg-slate-900 px-4 py-3 text-sm text-emerald-400", children: "\u2713 Submitted" }));
    }
    return (_jsxs("div", { className: "mt-3 rounded-xl border border-slate-700 bg-slate-900 p-4 space-y-4", children: [card.title && (_jsx("p", { className: "text-xs font-semibold uppercase tracking-wide text-slate-400", children: card.title })), card.fields.map((field) => (_jsx(CardFieldRenderer, { field: field, value: values[field.key], onChange: (v) => handleChange(field.key, v) }, field.key))), _jsxs("div", { className: "flex gap-2 pt-1", children: [_jsx("button", { onClick: () => void handleSubmit(), disabled: submitting, className: "rounded-lg bg-violet-600 px-4 py-1.5 text-xs font-medium text-white hover:bg-violet-500 disabled:opacity-50 transition-colors", children: submitting ? "Submitting…" : "Submit" }), _jsx("button", { onClick: onSkip, className: "rounded-lg px-4 py-1.5 text-xs font-medium text-slate-500 hover:text-slate-300 transition-colors", children: "Skip" })] }), error && (_jsxs("p", { className: "text-xs text-rose-400", children: ["Submit failed: ", error] }))] }));
}
